import { BUSINESS_BOOKING_ACTION_EVENT } from './gtm1-appointment'

const MAX_EVENT_PARAMETERS = 25
const LIMITED_BUSINESS_BOOKING_SCREENS: readonly string[] = [
  'new_appointment',
  'ba_deposit_amount',
  'ba_deposit_payment',
  'ba_deposit_result',
]
const BUSINESS_BOOKING_PRIORITY_PROPERTIES = [
  'screen_name',
  'event_action',
  'payment_method',
  'appointment_id',
  'transaction_id',
  'customer_id',
  'user_pos_id',
  'customer_type',
  'deposit_amount',
  'ba_value',
  'is_retry',
  'payment_input_attempt',
  'result_screen',
  'deposit_toggle',
  'require_deposit',
  'prepayment_toggle',
  'trusted_client',
  'app_version',
  'country',
  'device_type',
  'event_date',
  'business_id',
  'business_admin_status',
  'user_id',
  'logged_in_user_id',
  'booking_entry_source',
] as const

export interface GtmEvent {
  event?: string
  properties?: Record<string, unknown>
}

export function limitBusinessBookingParams (event: GtmEvent | null | undefined): GtmEvent | null | undefined {
  if (!event || typeof event !== 'object') {
    return event
  }

  const isBusinessBookingActionEvent = event?.event === BUSINESS_BOOKING_ACTION_EVENT
  const properties = event?.properties || {}
  const screenName = properties.screen_name as string | undefined
  const shouldLimitEvent = isBusinessBookingActionEvent
    && LIMITED_BUSINESS_BOOKING_SCREENS.includes(screenName)

  if (!shouldLimitEvent) {
    return event
  }

  if (Object.keys(properties).length <= MAX_EVENT_PARAMETERS) {
    return event
  }

  const limitedProperties: Record<string, unknown> = {}

  BUSINESS_BOOKING_PRIORITY_PROPERTIES.forEach(key => {
    if (
      Object.prototype.hasOwnProperty.call(properties, key)
      && Object.keys(limitedProperties).length < MAX_EVENT_PARAMETERS
    ) {
      limitedProperties[key] = properties[key]
    }
  })

  Object.keys(properties).forEach(key => {
    if (
      !Object.prototype.hasOwnProperty.call(limitedProperties, key)
      && Object.keys(limitedProperties).length < MAX_EVENT_PARAMETERS
    ) {
      limitedProperties[key] = properties[key]
    }
  })

  return {
    ...event,
    properties: limitedProperties,
  }
}
